import React, {FC, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormNameEnum} from 'filters-selections';
import {IWithMultiSelectOption} from 'filters-selections/models';
import {ItemWithPlaceholder} from 'filters-selections/selection/components';
import {fetchProgramYearsThunk, filtersYearsEntitiesCollectionSelector} from 'filters-selections/store';
import {Form} from 'forms';
import {IBindBaseEnumEntity, IOption, IWithDisabled} from 'models';

interface IProgramYearSelectProps extends IWithMultiSelectOption, IWithDisabled {
  label?: string;
  name?: string;
}

export const ProgramYearSelect: FC<IProgramYearSelectProps> = ({
  selectionType,
  disabled,
  label = 'Program Year',
  name = FormNameEnum.programYear,
}) => {
  const dispatch = useDispatch();
  const programYears = useSelector(filtersYearsEntitiesCollectionSelector) as IBindBaseEnumEntity[];
  const isMultiSelect = selectionType === 'multi';

  useEffect(() => {
    if (!programYears.length) {
      dispatch(fetchProgramYearsThunk());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options: IOption[] = useMemo(
    () =>
      programYears.map((programYear) => ({
        value: programYear.id,
        label: programYear.displayText,
      })),
    [programYears]
  );
  return (
    <ItemWithPlaceholder label={label} hasItems={!!programYears.length}>
      {isMultiSelect ? (
        <Form.SelectAutocomplete name={name} options={options} multiple disabled={disabled} />
      ) : (
        <Form.Select name={name} options={options} disabled={disabled} />
      )}
    </ItemWithPlaceholder>
  );
};
